import type { ApiRoute, NoQueryParams } from "../api"
import type { NotesValues } from "../vehicleDetails/overview/notes/NotesValues"
import type { NotesView } from "../vehicleDetails/overview/notes/NotesView"

export interface ChangeNotesPathParams {
	inventoryId: string
}

export const changeNotesRoute: ApiRoute<ChangeNotesPathParams, NoQueryParams, NotesValues, NotesView> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/notes`,
	method: "post",
	path: "/vehicles/:inventoryId/notes",
}
